var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multi-live-events"},_vm._l((_vm.messages),function(message,messageIndex){return _c(_vm.analyticMessageViewComponents[message.analyticType],{key:messageIndex,tag:"component",staticClass:"multi-live-events__analytic-message",attrs:{"analytic-message":message,"show-camera-info":true}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }